import { debug } from "console"
import React, { Component } from "react"
import { Container, Row, Col, Button, Form, Modal, Spinner } from "react-bootstrap"
import { FaAngleDown, FaPencilAlt, FaTimes } from "react-icons/fa"
import { BehaviorSubject, concat, of, Subject, Subscription } from "rxjs"
import { addProcessingCollectionTest, hasCachedCollectionTests, isProcessingCollection, ProcessingCollectionLabel } from "../../../api/CachedCollectionTest"
import AutoFilterCompany from "../../../api/Companies/CompanyModel/AutoFilterCompany"
import AutoFilterLocationsGet from "../../../api/Location/AutoFilterLocationsGet"
import AutoFilterLocation from "../../../api/Location/LocationModel/AutoFilterLocation"
import OrderResultRecord from "../../../api/OrderResults/OrderResultModel/OrderResultRecord"
import ServiceDetails from "../../../api/OrderResults/OrderResultModel/ServiceDetails"
import AutoFilterRegion from "../../../api/Regions/Model/AutoFilterRegion"
import PersonnelRegulatoryModes from "../../Accounts/RegulatoryMode/PersonnelRegulatoryModes"
import CompanyInput from "../../FormattedInputs/CompanyInput"
import CardRow from "./Cards/CardRow"
import Category from "../../../api/LabService/LabServiceModel/EmployeeCategory"
import { Typeahead } from "react-bootstrap-typeahead"
import { PoolRegulatoryMode } from "../../../api/Randoms/RandomsModel/PoolCompanyInfo"
import EmployeeCategoriesGetObservable from "../../../api/LabService/EmployeeCategoriesGet"
import EmployeeCategory from "../../../api/LabService/LabServiceModel/EmployeeCategory"
import TestEventUpdateData from "../../../api/OrderResults/OrderResultModel/TestEventUpdateData"
import { filter, map, switchMap } from "rxjs/operators"
import LabAccountsGetObservable, { FilteredLabAccountsGetObservable } from "../../../api/LabService/LabAccountsGet"
import LabAccount from "../../../api/Randoms/RandomsModel/LabAccount"
import TestToBePerform from "../../../api/LabService/LabServiceModel/TestToBePerform"


interface DrugTestCompareProps {
  currentRowInfo: OrderResultRecord
  currentServiceInfoNew: ServiceDetails
  currentServiceInfoOld: ServiceDetails
  isOnTrack?: boolean
  hasChanges: boolean
}

interface DrugTestCompareState {

}

export default class DrugTestCompare extends Component<DrugTestCompareProps, DrugTestCompareState> {

  dataRow(title: string, newValue: string, oldValue: string, ignoreChanges: boolean = false) {

    //{date ? FormatDate(value) : time ? FormatTime(value) : bool ? (value ? "Yes" : "No") : value}
    if ((newValue !== oldValue) || ignoreChanges){
      return (
        <Row className="p-1">
          <Col xs={6} md={3} className="test-property">{title}</Col>
          <Col xs={6} md={3} className="status-text">{newValue}</Col>
          <Col xs={3} md={1} className="status-text"></Col>
          <Col xs={6} md={3} className="status-text">{oldValue}</Col>
        </Row>
      )
    }
    return ""

  }

  render = () => {
    const { currentRowInfo, currentServiceInfoNew, currentServiceInfoOld, isOnTrack } = this.props
    const panelInfoNew = currentServiceInfoNew.Panel
    const panelInfoOld = currentServiceInfoOld.Panel
    const EventDataNew = currentServiceInfoNew.EventData
    const EventDataOld = currentServiceInfoOld.EventData
    const isDrug = currentServiceInfoNew.TestTypeDescription === "Drug"

    const primaryIdNew = (currentRowInfo.DonorID || "") + " " + EventDataNew?.PrimaryIDType
    const primaryIdOld = ""

    const personelIdNew = primaryIdNew
    const personelIdOld = primaryIdOld
    const testTypeOrSampleIDChanged = ((currentServiceInfoNew.TestTypeDescription !== currentServiceInfoOld.TestTypeDescription) || (currentServiceInfoNew.SampleID !== currentServiceInfoOld.SampleID))
    return (
      <Container>
        <Row>
          <Col md={8} className="pt-0">
            <h5>
              {!isOnTrack && <span className="text-uppercase">{currentServiceInfoNew.TestTypeDescription}</span>}TEST DETAIL COMP <span className="text-uppercase">{currentServiceInfoNew.CCFName}</span> {currentRowInfo ? currentRowInfo["DonorID"] : ""}
            </h5>
          </Col>
        </Row>
        <Row className="drug-test-info">
          <Col>
            {this.dataRow("PRIMARY ID", primaryIdNew, primaryIdOld)}
            {this.dataRow("PERSONNEL ID", personelIdNew, personelIdOld)}
            {this.dataRow(" ", " ", " ")}
            {this.props.hasChanges &&
              <Row className="status-alert">
                <Col xs={6} md={3}>Changes</Col>
                <Col xs={6} md={3}>New Value</Col>
                <Col xs={3} md={1}></Col>
                <Col xs={6} md={3}>Old Value</Col>
              </Row>
            }
            {this.dataRow("NAME", currentServiceInfoNew.CCFName, currentServiceInfoOld.CCFName)}
            {!isOnTrack && this.dataRow("REGULATORY MODE", EventDataNew?.RegulatoryModeName, EventDataOld?.RegulatoryModeName)}
            {!isOnTrack && this.dataRow("EMPLOYEE CATEGORY", EventDataNew?.EmployeeCategoryName, EventDataOld?.EmployeeCategoryName)}
            {this.dataRow("COMPANY NAME", EventDataNew?.CompanyName, EventDataOld?.CompanyName)}
            {!isOnTrack && this.dataRow("LOCATION", EventDataNew?.LocationName, EventDataOld?.LocationName)}
            {!isOnTrack && this.dataRow("LAB ACCOUNT", currentServiceInfoNew.LabAccountNumber, currentServiceInfoOld.LabAccountNumber)}
            {this.dataRow("REASON FOR TEST", currentServiceInfoNew.TestReasonDescription, currentServiceInfoOld.TestReasonDescription)}
            {isOnTrack && this.dataRow("Specimen / Reference ID", currentServiceInfoNew.SampleID, currentServiceInfoOld.SampleID)}
            {!isOnTrack && testTypeOrSampleIDChanged && this.dataRow("TEST TYPE", currentServiceInfoNew.TestTypeDescription, currentServiceInfoOld.TestTypeDescription, true)}
            {!isOnTrack && testTypeOrSampleIDChanged && this.dataRow("Specimen / Reference ID", currentServiceInfoNew.SampleID, currentServiceInfoOld.SampleID, true)}
            {!isOnTrack && this.dataRow("SAMPLE TYPE", currentServiceInfoNew.SampleTypeDescription, currentServiceInfoOld.SampleTypeDescription)}
            {!isOnTrack && this.dataRow("PANEL", panelInfoNew?.Description, panelInfoOld?.Description)}
            {!isOnTrack && this.dataRow("REGULATED", currentServiceInfoNew.DOT ? "Yes" : "No", currentServiceInfoOld.DOT ? "Yes" : "No")}
            {this.dataRow("EVENT STATUS", currentServiceInfoNew.TestReleaseStatusDescription, currentServiceInfoOld.TestReleaseStatusDescription)}
          </Col>
        </Row>
      </Container>
    )
  }
}
